var _defs, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMeeting = function SvgMeeting(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".meeting_svg__a{fill:none;stroke:currentColor;stroke-linecap:round;stroke-linejoin:round}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23,
    height: 16,
    x: 0.504,
    y: 0.5,
    className: "meeting_svg__a",
    rx: 1,
    ry: 1
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.504 16.5v7M4.504 23.5l7-7 7 7M.504 4.5h23",
    className: "meeting_svg__a"
  })));
};
export default SvgMeeting;